<script setup lang="ts">
import formatPrice from '@/helpers/formatPrice'
import type { LineItem, Invoice } from '@/types'
import { computed } from 'vue'

interface Props {
  items: LineItem[]
  totalPrice: Invoice['price']
  showMonthlyPayment?: boolean
  monthlyPayment?: number | null
}

const props = defineProps<Props>()

const titles = computed<string[]>(() => {
  return props.items.map((item) => `${item.name}`)
})

const formattedPrice = computed<string>(() => {
  if (props.showMonthlyPayment && props.monthlyPayment) {
    return `от ${formatPrice(props.monthlyPayment)} / мес`
  }

  return formatPrice(props.totalPrice)
})
</script>

<template>
  <div class="app-banner container">
    <div class="app-banner__meta">
      <h1 v-for="(title, index) in titles" :key="index" class="app-banner__title">
        {{ title }}
      </h1>
<!--      <p class="app-banner__subtitle">-->
<!--        {{ props.subtitle }}-->
<!--      </p>-->
    </div>
    <p class="app-banner__price">{{ formattedPrice }}</p>
  </div>
</template>

<style lang="scss" scoped>
.app-banner {
  display: flex;
  column-gap: 20px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: fluid(40, 32);
  border-radius: var(--rounded-xxl);
  background: var(--color-bg-banner);
  padding-block: 40px;

  h1 {
    margin-bottom: 0;
  }

  @include mobile {
    flex-direction: column;
    align-items: start;
    row-gap: 12px;
    padding: 20px 14px;
    max-width: calc(100% - 4px);
  }

  &__meta {
    display: flex;
    row-gap: fluid(16, 8);
    flex-direction: column;
  }

  &__subtitle {
    opacity: 0.6;
    font-weight: 600;
    font-size: fluid(20, 16);
    line-height: 1.35;
  }

  &__title {
    max-width: 600px;
  }

  &__price {
    color: var(--color-accent-alt);
    font-weight: 700;
    font-size: fluid(28, 22);
    @media screen and (min-width: 768px) {
      text-align: right;
      width: 300px;
    }
  }
}
</style>
